import { CaseStatus as CaseStatusType } from '@debbie/common/dist/cases/index.js';
import { objectBy } from '@debbie/common/dist/util/index.js';
import { useEndReasons } from '@debbie/cortex/dist/end-reasons/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const CaseStatus = (props) => {
    const { status, statusTime, endReasonId, compact } = props;
    const lang = useSelector((s) => s.lang);
    const endReasons = useEndReasons();
    const endReasonLookup = h.hasData(endReasons)
        ? objectBy(endReasons.data, (er) => er.id)
        : {};
    const endReason = endReasonId ? endReasonLookup[endReasonId] : null;
    // @ts-ignore
    const statusLabel = lang.cases[status] || status;
    const tooltipContent = compact
        ? `${statusLabel}${endReason && status === CaseStatusType.ENDED
            ? ` (${lang.endReason[endReason.handle] ??
                endReason.label})`
            : ''}${statusTime ? `, ${moment(statusTime).format(THEME.DATE_FORMAT_LONG)}` : ''}`
        : statusTime
            ? `${endReason && status === CaseStatusType.ENDED
                ? ` (${lang.endReason[endReason.handle] ??
                    endReason.label}), `
                : ''}${moment(statusTime).format(THEME.DATE_FORMAT_LONG)}`
            : undefined;
    if (compact) {
        return (React.createElement(CaseStatusCompact, { status: status, "data-tooltip-id": "tooltip-default", "data-tooltip-content": tooltipContent }));
    }
    return (React.createElement("span", null,
        React.createElement(CaseStatusStyled, { status: status, "data-tooltip-id": "tooltip-default", "data-tooltip-content": tooltipContent },
            statusLabel,
            ' ',
            React.createElement("span", { style: {
                    fontSize: '1.3em',
                    lineHeight: '0.4em',
                } }, "\u2139"))));
};
export default CaseStatus;
const CaseStatusStyled = styled.div `
  font-size: 0.8em;
  font-weight: bold;
  display: inline-block;
  position: relative;
  padding: 0 0 0 19px;
  color: ${(props) => {
    // @ts-ignore
    return THEME.STATUS_COLORS[props.status];
}};

  &:after {
    content: '';
    position: absolute;

    border-radius: 0.8em;
    background-color: ${(props) => {
    // @ts-ignore
    return THEME.STATUS_COLORS[props.status];
}};

    height: 13px;
    width: 13px;
    left: 0px;
    top: 2px;
  }
`;
const CaseStatusCompact = styled.span `
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${(props) => {
    // @ts-ignore
    return THEME.STATUS_COLORS[props.status];
}};
`;
//# sourceMappingURL=CaseStatus.js.map